<div hisDdKey="fs.res.publication.Publication.creators" #dDCreators>
	<p-panel header="{{dDCreators.ddLabeltext | hisUi}}">

	
	   	  	<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
	
	   		<his-plam>
	   			<p-autoComplete #content hisDdKey="fs.res.publication.Publication.publicationCreatorType"
	   				[(ngModel)]="creatorType"
	   				(onSelect)="selectCreatorType($event.value)"
	   				hisEagerDataSource="publicationCreatorTypeValue">
	   			</p-autoComplete>
	   		</his-plam>
	
	    	<div *ngIf="isTypeOfCreators()">
	    		<div [class]="dDCreators.required ? 'requireMessage' : 'infoMessage'" *ngIf="creators && creators.length === 0">
	    			<span *ngIf="isTypeOfAuthor()" [innerHTML]="'fs.res.publication.noAssignedAuthor' | hisUi"></span>
	    			<span *ngIf="isTypeOfEditor()" [innerHTML]="'fs.res.publication.noAssignedEditor' | hisUi"></span>
	    		</div>
	
	    		<button *ngIf="isTypeOfAuthor()" (click)="addCreator()" hisImage="plus_circ_green" class="transparent"><span>{{'fs.res.publication.edit.assignAuthor' | hisUi}}</span></button>
	    		<button *ngIf="isTypeOfEditor()" (click)="addCreator()" hisImage="plus_circ_green" class="transparent"><span>{{'fs.res.publication.edit.assignEditor' | hisUi}}</span></button>
	
	    		<div *ngIf="creators && creators.length > 0">
	    			<ul class="listSimple">
	    				<li class="layoutBlock" *ngFor="let creator of creators; index as i">
	    					<div class="columnTwoThird">
	    						<ng-container *ngIf="isTypeOfOrganisation(); else humanCreator">
	    						</ng-container>
	    						<ng-template #humanCreator>
	    							<img *ngIf="creator.person; else externalPerson" hisImage="USER" title="{{'fs.res.publication.creators.internalPerson' | hisUi}}" class="inlineicon">
	    							<ng-template #externalPerson>
	    								<img hisImage="USER_GO" title="{{'fs.res.publication.creators.externalPerson' | hisUi}}" class="inlineicon">
	    							</ng-template>
	    							<span class="textBold">
	    								<!-- #266214 Beim Bibtex-Import können die Schöpfer von Sammelbänden den Typ Herausgeber erhalten. Deshalb kann es auch hier passieren dass es keinen Vornamen gibt. -->
	    								<span *ngIf="creator.nameprefix">{{creator.nameprefix}} </span>{{creator.creatorname}}<span *ngIf="creator.namesuffix"> {{creator.namesuffix}}</span><span *ngIf="creator.firstname && creator.firstname.trim() !== ''">, {{creator.firstname}}</span>
	    							</span>
	    							<br/>
	    							<ng-container *ngFor="let creatorOrganization of creator.creatorOrganizations; last as isLast">
	    								<img hisImage="SPACER" class="inlineicon">
	    								<span *ngIf="creatorOrganization.organization; else researchPartner">{{creatorOrganization.organization.text}}</span>
	    								<ng-template #researchPartner>{{creatorOrganization.researchPartner?.defaulttext}} (ext.)</ng-template>
	    								<br *ngIf="(creator.creatorOrganizations.length > 1) && !isLast" />
	    							</ng-container>
	    							
	    							<div *ngIf="hasOrcidId(creator)">
										<img hisImage="SPACER" class="inlineicon">
										<span class="textBold">{{'fs.res.publication.import.orcid.columnHeader' | hisUi}}: </span>
										<span>{{creator.orcid[0]}}</span>
									</div>
	    							
	    						</ng-template>
	    					</div>
	    					<div class="columnOneThird">
	    						<button (click)="editCreator(creator)" hisImage="PENCIL" class="icon"
	    						    title="{{'fs.res.common.person.editOf' | hisUi:(creator.firstname + ' ' + creator.creatorname):getEditOfType()}}"></button>
	    						<button (click)="moveDown(creator)" *ngIf="creator.sortorder !== creators.length; else spaceholder" hisImage="ARROW_DOWN" class="icon"
                                    title="{{'fs.res.publication.creators.moveDownOf' | hisUi:(creator.firstname + ' ' + creator.creatorname)}}"></button>
	    						<button (click)="moveUp(creator)" *ngIf="creator.sortorder !== 1; else spaceholder" hisImage="ARROW_UP" class="icon"
                                    title="{{'fs.res.publication.creators.moveUpOf' | hisUi:(creator.firstname + ' ' + creator.creatorname)}}"></button>
	    						<button (click)="deleteCreator(i)" hisImage="DELETE" class="icon"
                                    title="{{'common.removeAssignmentOf' | hisUi:(creator.firstname + ' ' + creator.creatorname)}}"></button>
	    						<ng-template #spaceholder>
	    						    <ng-container *ngIf="(creators.length > 1 && creator.sortorder === 1) || (creators.length > 1 && creator.sortorder === creators.length)">
                                        <button disabled="true" hisImage="SPACER" class="icon" style="pointer-events: none;"></button>
	    						    </ng-container>
	    						</ng-template>
	    					</div>
                            <div class="columnTwoThird">
                                <hr width="100%" *ngIf="creators.length > i+1">
                            </div>
	    				</li>
	    			</ul>
	    			<div class="clearer"></div>
	    		</div>
	    	</div>
	    	<div *ngIf="isTypeOfOrganisation()">
	    		<!-- no record found -->
	    		<div *ngIf="creators && creators.length === 0" class="requireMessage">
	    			{{'fs.res.publication.noAssignedOrgunit' | hisUi}}
	    		</div>
	    		<button *ngIf="!isAddCreator" (click)="setIsAddCreator()" hisImage="plus_circ_green" class="transparent"><span>{{'fs.res.publication.addOrganisation' | hisUi}}</span></button>
	
	    		<!-- internal organization units -->
	    		<res-internal-organization-edit [organizations]="internalOrganizations"
	    			[isAddOrganization]="isAddCreator"
	    			(selectedInternalOrgUnitChange)="internalOrganizationsChange($event)"
	    			(deleteInternalOrgUnitChange)="deleteOrganizationChange($event)">
	    		</res-internal-organization-edit>
	
	    		<!-- external organization units / research partner -->
	    		<res-external-organization-edit
	    			[organizations]="externalOrganizations"
	    			[isAddOrganization]="isAddCreator"
	    			[showCreateLink]="true"
	    			(selectedExternalOrgUnitChange)="externalOrganizationsChange($event)"
	    			(deleteExternalOrgUnitChange)="deleteOrganizationChange($event)"
	    			(createExternalOrgUnitChange)="createExternalOrgUnitChange()">
	    		</res-external-organization-edit>
	
	    		<!-- create new external organization in popup -->
	    		<res-external-organization-create-dialog *ngIf="visibility" [(visibility)]="visibility"
	    			(saveDialogChange)="saveDialogChange($event)">
	    		</res-external-organization-create-dialog>
	    	</div>
	
	    	<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
	
	</p-panel>
</div>

<res-publication-creator-wizard #creatorWizard (applyChangedCreator)="applyChangedCreator($event)"></res-publication-creator-wizard>
